import { UserService } from '@/user/apis/user/user.api'
import { UserInfo, PartnerList, OwnedPartnerOrg } from '@/user/models/user-info'
import Cookies from 'js-cookie'

export default {
  namespaced: true,
  state: () => ({
    userInfo: null,
    userPartnerList: null,
    ownedPartnerOrg: null,
    partnerId: Cookies.get('EDU_SECURITY_PARTNER_ID'),
    emailVerifyId: null,
    isSuccess: false,
  }),
  mutations: {
    userInfo(state, value) {
      state.userInfo = value
    },
    userPartnerList(state, value) {
      state.userPartnerList = value
    },
    ownedPartnerOrg(state, value) {
      state.ownedPartnerOrg = value
    },
    selectPartnerId(state, value) {
      Cookies.set('EDU_SECURITY_PARTNER_ID', value)
      state.partnerId = value
    },
    emailVerifyId(state, value) {
      state.emailVerifyId = value
    },
    isConfirmSuccess(state, value) {
      state.isSuccess = value
    },
  },
  actions: {
    async registerUserInfo({ commit }) {
      try {
        const data = await UserService.current()
        commit('userInfo', new UserInfo(data))
        return true
      } catch (e) {
        return false
      }
    },
    async unregisterUserInfo({ commit }) {
      commit('userInfo', null)
      commit('userPartnerList', null)
      commit('selectPartnerId', null)
    },
    async userPartnerInfo({ state, commit }) {
      const data = await UserService.orgs()
      commit('userPartnerList', new PartnerList(data))
      return state.userPartnerList
    },
    async ownedPartnerOrg({ state, commit }) {
      const data = await UserService.ownedOrg()
      if (data) {
        commit('ownedPartnerOrg', new OwnedPartnerOrg(data))
      }
      return state.ownedPartnerOrg
    },
  },
  getters: {
    userInfo(state) {
      return state.userInfo
    },
    userPartnerList(state) {
      return state.userPartnerList
    },
    ownedPartnerOrg(state) {
      return state.ownedPartnerOrg
    },
    selectPartnerId(state) {
      return state.partnerId
    },
    emailVerifyId(state) {
      return state.emailVerifyId
    },
    isConfirmSuccess(state) {
      return state.isSuccess
    },
  },
}
